import React, { useState } from 'react';
import AddQuestionModal from './components/AddQuestion';
import { IFetchQuestionFilters, useFetchQuestions } from '../../../hooks/admin/question/question';

interface Question {
  question: string;
  answer:string
  category: string;
  status: string;
  source: string;
  lastUpdated: string;
}

const QAManagement: React.FC = () => {
const user_id=2
  const [questionFilter, setQuestionFilter] = useState<IFetchQuestionFilters>({
user_id,
category_id:"",
flag_status:"",
is_active:false,
limit:10,
offset:1,
search:""

  })

const questionsAPI= useFetchQuestions(questionFilter)

  const [questions, setQuestions] = useState<Question[]>([
    {
      question: "What is the company's work from home policy?",
      answer: "lorem10",
      category: "HR",
      status: "Approved",
      source: "HR Policy v2.1",
      lastUpdated: "01-12-2024",
    },
    {
      question: "How do I reset my system password?",
      answer:"This is the answer for whatever the question of a long statement might looks like. This might not be accurate but at least it solves the job we are trying to fix. Let me know if you're impressed or not",
      category: "Technical",
      status: "Pending",
      source: "IT Manual 2025",
      lastUpdated: "01-01-2025",
    },
    // Add more questions here...
  ]);

  const [activeQuestion, setActiveQuestion]= useState<Question>()
const [showModal, setShowModal] = useState(false);


const handleEditQuestion = (question?: Question) => {
    setActiveQuestion(question)
    setShowModal(true);
}
const closeEditModal=()=>{
    setActiveQuestion(undefined)
    setShowModal(false);
}

const handleSaveQuestion = (question: Question) => {

console.log({question})
}



  return (
    <div className="bg-gray-100 min-h-screen font-sans">
      {/* Header (replace with your actual header component) */}
     

      <div className="container mx-auto p-6 ">
        <div className="bg-white shadow rounded p-6">
          <div className="flex justify-between items-center mb-16">
            <h2 className="text-xl font-bold text-gray-800">Question & Answer Management</h2>
            <button
             className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
             onClick={()=>handleEditQuestion()}

             >
              + Add Question
            </button>
          </div>

          <div className="flex items-center justify-end mb-8">
            <div className="relative mr-8">
              <input
                type="text"
                placeholder="Search questions..."
                className="border border-gray-300 rounded px-3 py-2"
              />
              {/* Search Icon (replace with your icon) */}
              <div className="absolute right-2 top-1/2 transform -translate-y-1/2">🔍</div>
            </div>
            <div>
              <label htmlFor="categoryFilter" className="mr-2">Filter by:</label>
              <select id="categoryFilter" className="border border-gray-300 rounded px-3 py-2">
                <option>All Categories</option>
                {/* Add more options as needed */}
              </select>
            </div>
          </div>


          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Question</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Answer</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Source</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Updated</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody>
              {questionsAPI.data?.map((q, index) => (
                <tr key={index} className={`text-sm ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}`}>
                  <td className="px-4 py-4 ">{q.text}</td>
                  <td className="px-4 py-4 ">{q.answer}</td>
                  <td className="px-4 py-2">{"q.category"}</td>
                  <td className="px-4 py-2">
                    <span className={q.flag_status === 'yes' ? 'text-green-500' : 'text-yellow-500'}>{q.flag_status}</span>
                  </td>
                  <td className="px-4 py-2">{"q.source"}</td>
                  <td className="px-4 py-2">{"q.lastUpdated"}</td>
                  <td className="px-4 py-2 ">
                    {/* Action Icons (replace with your icons) */}
                    <button className="mr-4" onClick={()=>handleEditQuestion({
                      answer:q.answer,
                      category:"q.category",
                      lastUpdated:"q.last",
                      question:q.text,
                      source:"q.source",
                      status:"q.status"
                    })}>

                    <span>✏️</span>
                    </button>
                    <button>

                     <span>🗑️</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="mt-4 flex justify-between items-center">
            <p className="text-gray-600">Showing 1-2 of 24 questions</p>
            <div>
              <button className="px-3 py-1 rounded mr-2 bg-gray-200 hover:bg-gray-300">Previous</button>
              <button className="px-3 py-1 rounded bg-blue-500 hover:bg-blue-700 text-white">Next</button>
            </div>
          </div>
        </div>
      </div>

      <AddQuestionModal isOpen={showModal} onSave={handleSaveQuestion} onClose={closeEditModal} initialData={activeQuestion}/>
    </div>
  );
};

export default QAManagement;